import { APIRequest, APIRequestDtoImpl } from '../../apiRequest';

export interface SubscribeUnSubscribeFlashMessageRequest extends APIRequest
{
    getMsisdn(): string;
}

export class SubscribeUnSubscribeFlashMessageRequestImpl extends APIRequestDtoImpl implements SubscribeUnSubscribeFlashMessageRequest
{
    constructor(private msisdn: string)
    {
        super();
    }
    getMsisdn(): string {
       return this.msisdn;
    }  
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/flashmessage/subscribeunsubscribe/subscribeunsubscribeflashmessagesrequest.tsx